import DOMElement from "../../../../../components/base/dom-element";
import LocalizationsHelper from "../../../../../lib/localizations-helper";
import AgPayButtonService from "../components/ag-pay-button-service";

export default class CheckoutAuthenticatedFooterBlockElement extends DOMElement {
    constructor(props = {}) {
        super('div', props);
    }

    _initProps() {
        super._initProps();

        this.class = DOMElement.classListFrom('f-footer checkout-form-footer -mobile-sticky', this.class);
        this.attributes = Object.assign(this.attributes, {
            'data-type': 'checkout-auth'
        });
        this.child = new DOMElement('div', {
            class: 'f-footer-buttons',
            children: [
                AgPayButtonService.getButtonElement(),
                new DOMElement('button', {
                    class: 'button -xl -primary -p -full-size f-submit-button',
                    attributes: {
                        type: 'button',
                        'data-form': 'submit'
                    },
                    text: LocalizationsHelper.get('component.checkout.goToPayment')
                })
            ]
        });
    }
}